module.exports = __webpack_public_path__ + "static/img/bg-en.202c5817.png";